import React from 'react';
import { Icon } from '@iconify/react';

function Career() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="text-center">
        <div className="mb-4 flex justify-center">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon icon="fluent:briefcase-24-regular" width="32" height="32" className="text-primary" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Coming Soon</h1>
        <p className="text-sm text-gray-600">Career Path feature is under development</p>
      </div>
    </div>
  );
}

export default Career;